export const occurrenceLabels = {
  singular: 'Occurrence',
  plural: 'Occurrences',
  crossSearchTitle: 'Occurrences',
  informationSectionTitle: 'Occurrences',
  addNewButton: 'Add new Occurrence',
} as const
